function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraphComponent from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component";
import classnames from "classnames";
import AssetComponent from "/components/core/asset/asset-component";
import TopLogosComponent from "segments/desktop/logos/layouts/top-logos/top-logos-component.js";
import { trackEvent } from "services/bigbrain-service";
import { ASSET_COMPONENT_VIDEO_STARTED } from "constants/bigbrain-event-types";
import DefaultProps from "./default-props";
import { StyledVideoBackgroundAssetComponent } from "./video-background-asset-component.scss";
const VideoBackgroundAssetComponent = (props)=>{
    var _assetConfig_video;
    const { assetConfig, fullParagraphConfig, addDarkOverlay, hideBlackBars, alignToLogo, paragraphAdvancedProps, logosProps, topLogosAdvancedProps, segmentHeight, segmentMinHeight, segmentMaxHeight, videoPlayerWidth, videoPlayerMinWidth, videoPlayerHeight, videoPlayerPositionTop, videoPlayerPositionLeft, logosBottomMargin, isCentrilizeContent } = props;
    const _ref = logosProps || {}, { useLogos } = _ref, restOfLogosProps = _object_without_properties(_ref, [
        "useLogos"
    ]);
    const videoHeight = assetConfig === null || assetConfig === void 0 ? void 0 : (_assetConfig_video = assetConfig.video) === null || _assetConfig_video === void 0 ? void 0 : _assetConfig_video.height;
    const onVideoStart = ()=>{
        var _assetConfig_video_src_formats, _assetConfig_video_src, _assetConfig_video;
        trackEvent(ASSET_COMPONENT_VIDEO_STARTED, {
            info1: assetConfig === null || assetConfig === void 0 ? void 0 : (_assetConfig_video = assetConfig.video) === null || _assetConfig_video === void 0 ? void 0 : (_assetConfig_video_src = _assetConfig_video.src) === null || _assetConfig_video_src === void 0 ? void 0 : (_assetConfig_video_src_formats = _assetConfig_video_src.formats) === null || _assetConfig_video_src_formats === void 0 ? void 0 : _assetConfig_video_src_formats[0]
        });
    };
    return /*#__PURE__*/ _jsxs(StyledVideoBackgroundAssetComponent, {
        videoHeight: videoHeight,
        segmentHeight: segmentHeight,
        segmentMinHeight: segmentMinHeight,
        segmentMaxHeight: segmentMaxHeight,
        videoPlayerWidth: videoPlayerWidth,
        videoPlayerMinWidth: videoPlayerMinWidth,
        videoPlayerHeight: videoPlayerHeight,
        videoPlayerPositionTop: videoPlayerPositionTop,
        videoPlayerPositionLeft: videoPlayerPositionLeft,
        logosBottomMargin: logosBottomMargin,
        isCentrilizeContent: isCentrilizeContent,
        paragraphMarginTop: paragraphAdvancedProps === null || paragraphAdvancedProps === void 0 ? void 0 : paragraphAdvancedProps.marginTop,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("video-wrapper", {
                    "hide-black-bars": hideBlackBars
                }),
                children: [
                    /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, assetConfig), {
                        hideControls: true,
                        hideBlackBars: hideBlackBars,
                        onStart: onVideoStart
                    })),
                    addDarkOverlay && /*#__PURE__*/ _jsx("div", {
                        className: "dark-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("content-wrapper", {
                    "align-to-logo": !!alignToLogo
                }),
                children: [
                    /*#__PURE__*/ _jsx(FullParagraphComponent, _object_spread({}, fullParagraphConfig, paragraphAdvancedProps)),
                    useLogos && /*#__PURE__*/ _jsx(TopLogosComponent, _object_spread({}, restOfLogosProps, topLogosAdvancedProps))
                ]
            })
        ]
    });
};
VideoBackgroundAssetComponent.defaultProps = DefaultProps;
export default VideoBackgroundAssetComponent;
